import { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const DEFAULT_ORDER = ["explore", "discover", "plan", "about"];

// Child link ids per dropdown group, in default order — must match the
// `id` given to each item in src/components/Navbar.jsx's navGroups.
const DEFAULT_CHILDREN = {
  discover: ["categories", "adventures", "culture", "photo-guide"],
  plan: ["hotels", "local-guides", "guide", "cuisine", "festivals"],
};

export function useNavOrder() {
  const [order, setOrder] = useState(DEFAULT_ORDER);
  const [childOrder, setChildOrder] = useState(DEFAULT_CHILDREN);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDoc(doc(db, "siteSettings", "navOrder"))
      .then((snap) => {
        if (!snap.exists()) return;
        const data = snap.data();
        const savedOrder = data.order || DEFAULT_ORDER;
        const savedItems = data.items || [];

        // merge in any default keys not yet present in a previously saved order
        const missing = DEFAULT_ORDER.filter((id) => !savedOrder.includes(id));
        const fullOrder = [...savedOrder, ...missing];
        // filter out hidden nav groups
        const visible = fullOrder.filter((id) => {
          const item = savedItems.find((i) => i.id === id);
          return !item?.hidden;
        });
        setOrder(visible);

        const nextChildOrder = {};
        for (const groupKey of Object.keys(DEFAULT_CHILDREN)) {
          const savedGroup = savedItems.find((i) => i.id === groupKey);
          const savedChildren = savedGroup?.children;
          if (Array.isArray(savedChildren) && savedChildren.length > 0) {
            const savedChildIds = savedChildren.map((c) => c.id);
            const missingChildren = DEFAULT_CHILDREN[groupKey].filter(
              (id) => !savedChildIds.includes(id),
            );
            const fullChildOrder = [...savedChildIds, ...missingChildren];
            nextChildOrder[groupKey] = fullChildOrder.filter((id) => {
              const c = savedChildren.find((sc) => sc.id === id);
              return !c?.hidden;
            });
          } else {
            nextChildOrder[groupKey] = DEFAULT_CHILDREN[groupKey];
          }
        }
        setChildOrder(nextChildOrder);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return { order, childOrder, loading };
}
